<template>
  <div class="centerPage">
    <div class="bannerEdit">
      <el-form :model="banner" ref="ruleForm">
        <el-upload
            name="uploadFile"
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-change="changeUpload">
          <div class="avatar" v-if="imageUrl" :style="'backgroundImage: url('+imageUrl+')'"></div>
          <!--                    <img v-if="imageUrl" :src="imageUrl" class="avatar">-->
          <div v-else class="el-upload__text">点击上传<br/>最佳尺寸：438*664</div>
        </el-upload>

        <!-- vueCropper 剪裁图片实现-->
        <el-dialog title="图片剪裁" :visible.sync="dialogVisible" top="20px" :close-on-press-escape="false"
                   :close-on-click-modal="false" append-to-body>
          <div class="cropper-content">
            <div class="cropper" style="text-align:center">
              <vueCropper
                  ref="cropper"
                  :img="option.img"
                  :outputSize="option.size"
                  :outputType="option.outputType"
                  :info="true"
                  :canScale="option.canScale"
                  :autoCrop="option.autoCrop"
                  :autoCropWidth="option.autoCropWidth"
                  :autoCropHeight="option.autoCropHeight"
                  :fixedBox="option.fixedBox"
                  :fixed="option.fixed"
                  :fixedNumber="option.fixedNumber"
                  :canMove="option.canMove"
                  :canMoveBox="option.canMoveBox"
                  :original="option.original"
                  :centerBox="option.centerBox"
                  :infoTrue="option.infoTrue"
                  :full="option.full"
                  :enlarge="option.enlarge"
                  :mode="option.mode"
              >
              </vueCropper>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
          </div>
        </el-dialog>

        <el-form-item prop="imgUrl">
          <el-input placeholder="请输入链接地址" v-model="banner.imgUrl"></el-input>
        </el-form-item>
        <el-form-item prop="matchText">
          <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 3}"
              placeholder="请输入简要描述"
              v-model="banner.matchText">
          </el-input>
        </el-form-item>
        <el-form-item class="btn">
          <el-button @click="resetForm('ruleForm')">重置</el-button>
          <el-button @click="save()">保存</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="bannerEdit" v-for="(item,index) in bannerList" :key="index">
      <el-form :model="bannerEdit" ref="editForm">
        <el-upload
            v-if="editId == item.id"
            name="uploadFile"
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-change="changeUpload1">
          <!--:on-success="handleAvatarSuccessEdit"-->
          <div class="avatar" v-if="imgUrlEdit" :style="'backgroundImage: url('+imgUrlEdit+')'"></div>
          <!--<img v-if="item.img" :src="item.img" class="avatar">-->
          <div v-else class="el-upload__text">点击上传<br/>最佳尺寸：{{ option.autoCropWidth }}*{{ option.autoCropHeight }}</div>
        </el-upload>
        <div v-else class="avatar-uploader">
          <div class="avatar" v-if="item.imgPath" :style="'backgroundImage: url('+item.imgPath+')'"></div>
        </div>

        <el-form-item style="height: 30px;">
          <el-input placeholder="请输入链接地址" class="inputC" v-if="editId ==item.id"
                    style="border: none; padding: 0"
                    v-model="bannerEdit.imgUrl"></el-input>
          <el-tooltip :content="item.imgUrl" placement="bottom" effect="light" v-else>
            <span class="inputC" style="text-overflow: ellipsis;overflow: hidden;">{{ item.imgUrl }}</span>
          </el-tooltip>
          <!--						<span class="inputC" v-else :title="item.imgUrl" style="text-overflow: ellipsis;overflow: hidden;">{{item.imgUrl}}</span>-->
        </el-form-item>
        <el-form-item style="height: 70px" prop="matchText">
          <el-input class="inputText"
                    v-if="editId ==item.id"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 3}"
                    placeholder="请输入简要描述"
                    style="border: none; padding: 0"
                    v-model="bannerEdit.matchText">
          </el-input>
          <span class="inputText" v-else>{{ item.matchText }}</span>
        </el-form-item>
        <el-form-item class="btn">
          <el-popconfirm title="确定删除吗？" @confirm="del(item.id)" style="margin-right: 10px">
            <el-button slot="reference" class="delete">删除</el-button>
          </el-popconfirm>

          <el-button v-if="editId ==item.id" @click="saveEdit()">保存</el-button>
          <el-button v-else
                     @click="editId = item.id,bannerEdit.id=item.id,bannerEdit.imgUrl=item.imgUrl,
							   bannerEdit.matchText=item.matchText,bannerEdit.imgPath=item.imgPath,
								imgUrlEdit=item.imgPath">编辑
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import SysCons from '@/api/common';
import {tooltip} from 'element-ui';
// 使用vue-cropper 图片上传组件
import {VueCropper} from 'vue-cropper';
import html2canvas from "html2canvas"

export default {
  name: "indexBanner",
  data() {
    return {
      uploadUrl: SysCons.bannerUploadUrl || '',
      imageUrl: '',// 新增banner上传组件显示上传的图片
      imgUrlEdit: '',// 修改banner上传组件显示上传的图片
      banner: {// 新增banner对象
        imgPath: '',
        imgUrl: '',
        matchText: '',
      },
      bannerList: [],// 获取的bannerlist
      editId: -999,// 当前编辑状态的bannerID
      bannerEdit: {
        imgPath: '',
        imgUrl: '',
        matchText: ''
      },// 当前编辑的banner对象

      fileImg: '',
      dialogVisible: false,
      dialogVisible1: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        info: true, // 裁剪框的大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 2190, // 默认生成截图框宽度
        autoCropHeight: 3320, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [438, 664], // 截图框的宽高比例
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        full: false, // 是否输出原图比例的截图
        enlarge: '1', // 图片根据截图框输出比例倍数
        mode: 'contain' // 图片默认渲染方式
      },
      // 防止重复提交
      loading: false,
      uploadType: 0,//上传类型
    }
  },
  inject: ['reload'],
  mounted() {
    this.getData()
  },
  components: {[tooltip.name]: tooltip, VueCropper},
  methods: {
    save() {// 新增banner
      let vm = this;
      if ($.trim(vm.banner.imgPath) == 0) {
        vm.$message('请先上传图片');
        return;
      }
      let params = {
        imgPath: vm.banner.imgPath,
        imgUrl: vm.banner.imgUrl,
        matchText: vm.banner.matchText,
      }
      vm.$ajax.post(SysCons.api.banner.index.add, params)
          .then((res) => {
            if (res.data.status == 'success') {
              vm.$message({
                type: "success", message: res.data.message, onClose: () => {
                  this.reload()
                }
              })
            } else {
              vm.$message({
                message: res.data.message,
                type: 'warning'
              });
            }
          }).catch(err => {
        console.error(err);
        vm.$message.error('操作失败');
      })
    },
    saveEdit() {// 保存修改的banner
      let vm = this;
      if ($.trim(vm.bannerEdit.imgPath) == 0) {
        vm.$message('请先上传图片');
        return;
      }
      let params = {
        id: vm.bannerEdit.id,
        imgPath: vm.bannerEdit.imgPath,
        imgUrl: vm.bannerEdit.imgUrl,
        matchText: vm.bannerEdit.matchText,
      }
      vm.$ajax.post(SysCons.api.banner.index.update.replace("{id}", params.id), params)
          .then((res) => {
            if (res.data.status === 'success') {
              vm.$message({
                type: "success", message: res.data.message, onClose: () => {
                  this.reload()
                }
              })
            } else {
              vm.$message.error(res.data.message);
            }
          }).catch((err) => {
        console.error(err);
        vm.$message.error('操作失败');
      })
    },
    getData() {
      this.$ajax.get(SysCons.api.banner.index.list)
          .then((res) => {
            if (res.data.status == 'success' && res.data.list) {
              this.bannerList = res.data.list
            }
          })
    },
    handleAvatarSuccess(res, file) {// 新增上传组件
      this.imageUrl = URL.createObjectURL(file.raw);
      this.banner.imgPath = res.message;
    },
    handleAvatarSuccessEdit(res, file) {// 编辑上传组件
      this.imgUrlEdit = URL.createObjectURL(file.raw);
      this.bannerEdit.imgPath = res.message;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    del(id) {
      let vm = this;
      vm.$ajax.post(SysCons.api.banner.index.del.replace("{id}", id))
          .then((res) => {
            if (res.data.status == 'success') {
              vm.$message({
                type: 'success', message: res.data.message, onClose: () => {
                  vm.reload();
                }
              })
            } else {
              vm.$message.error(res.data.message);
            }
          }).catch((err) => {
        console.error(err);
        vm.$message.error('操作失败');
      });
    },
    // 上传按钮 限制图片大小
    changeUpload(file, fileList) {
      this.uploadType = 0;
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!')
        return false
      }
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = URL.createObjectURL(file.raw);
        this.dialogVisible = true
      })
    },
    // 上传按钮 限制图片大小
    changeUpload1(file, fileList) {
      this.uploadType = 1;
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!')
        return false
      }
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = URL.createObjectURL(file.raw);
        this.dialogVisible = true
      })
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this;
      // 获取截图的base64 数据
      this.$refs.cropper.getCropData((data) => {
        // do something
        this.loading = true;
        // 把图片上传到服务器
        setTimeout(() => {
          this.loading = false;
          this.dialogVisible = false;
          this.fileImg = data;

          let formData = new FormData();
          // formData.append("uploadFile",data);

          var arr = data.split(','), mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          formData.append('uploadFile', new File([u8arr], 'test.png', {type: mime}));

          this.$ajax.post(SysCons.bannerUploadUrl, formData)
              .then(function (res) {
                if (res.data.status === 'success') {
                  if (that.uploadType === 0) {
                    that.banner.imgPath = res.data.message;
                    that.imageUrl = res.data.message;
                  } else {
                    that.imgUrlEdit = res.data.message;
                    that.bannerEdit.imgPath = res.data.message;
                  }
                } else {
                  that.$message.error(res.data.message);
                }
              }).catch((err) => {
            console.error(err);
            that.$message.error('操作失败');
          })
        }, 1000)
      });
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/banner.scss';
.centerPage{
  width: auto;
}
.cropper-content {
  height: 100%;

  .cropper {
    width: auto;
    height: 100%;
  }
}

.bannerEdit {
  .avatar-uploader {
    height: 320px;
  }
}
</style>
<style lang="css">
.el-dialog__body {
  height: 680px;
  padding: 0 20px;
}

</style>